import {observer} from "mobx-react";
import {
    ContentExportImport,
    ContentFilter,
    ContentInput,
    ContentInputAndListableUserDeleted,
    ContentInputSearchAndFilter
} from "./styled";
import InputSearchGeneric from "@dropDesk/presentation/components/inputs/input_search";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import {useBetween} from "use-between";
import {useModalContacts} from "@dropDesk/presentation/pages/client/ui/contacts/search/modals/handle_change_visible";
import {ContentInputSearch} from "@dropDesk/presentation/pages/ticket/ui/search/search_bar/styled";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import Filters from "@dropDesk/presentation/pages/client/ui/contacts/search/search_bar/filters";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";


const SearchBar = observer(
    ({
         onSearch,
         loading,
         visibleInputSearch,
         visibleButtonsOfActions,
         visibleButtonRestore,
         clientFilter,
         setClientFilter
     }: {
        onSearch: (searchParam: string) => void,
        loading: boolean
        visibleInputSearch: boolean,
        visibleButtonsOfActions: boolean,
        visibleButtonRestore: boolean,
        clientFilter: ClientEntity | null,
        setClientFilter: (clientFilter: ClientEntity | null) => void
    }) => {

        const {setVisibleModalExport, setVisibleModalRestore} = useBetween(useModalContacts);
        const appController = useInjection(AppController);
        return (
            <ContentFilter>
                <ContentInputAndListableUserDeleted>
                    <ContentInput>
                        {visibleInputSearch &&
                            <ContentInputSearchAndFilter>
                                <ContentInputSearch>
                                    <InputSearchGeneric
                                        inputSearchPlaceholder="Pesquise por todos os contatos"
                                        loading={loading}
                                        onSearch={(value) => onSearch(value)}
                                        defaultLimitInputSearch={ConstantsKeys.defaultNewLimitInputSearch}
                                        size={'large'}
                                    />
                                </ContentInputSearch>
                                <Filters
                                    loading={loading}
                                    onSearch={(value) => onSearch(value ?? '')}
                                    clientFilter={clientFilter}
                                    setClientFilter={setClientFilter}
                                />
                            </ContentInputSearchAndFilter>
                        }

                        {visibleButtonRestore && <ButtonNew
                            marginLeft={0}
                            label={'Restaurar'}
                            onClick={() => setVisibleModalRestore(true)}
                            nameLeftIcon={ICONS_DROPDESK.restore}
                            sizeLeftIcon={16}
                            disabled={loading}
                        />}
                    </ContentInput>

                </ContentInputAndListableUserDeleted>

                <ContentExportImport>

                    {visibleButtonsOfActions && appController.user?.permissionAdmin && <ButtonNew
                        marginLeft={10}
                        label={'Exportar'}
                        onClick={() => setVisibleModalExport(true)}
                        nameLeftIcon={ICONS_DROPDESK.excel}
                        sizeLeftIcon={15}
                        disabled={loading}
                    />}

                </ContentExportImport>
            </ContentFilter>
        )
    })
export default SearchBar;
